<template>
	<div class="downloadfile">
		<ul class="newList">
		    <li v-for="(result,index) in resultDataList">
		    	<router-link :to="{ name: 'detail', params: { id: result.id }}" target="_blank" @click.native="$track([['pagetype',colname+'-文章-id:'+result.id+'-点击']])">
		    		{{result.title}}<i></i></router-link>
		    	<!-- <p>{{result.summary.indexOf('attachment id=')>-1?' ':result.summary}}</p> -->
		    	<!-- <em>{{result.publishtime?result.publishtime.substring(0,10):''}}</em> -->
		    </li>
		</ul>
		
		<div class="pagediv">
			<el-pagination
				@size-change="changePageSize"
				@current-change="changeSearchPage"
				:current-page="pageNum"
				
				:page-size="pageSize"
				layout="total, prev, pager, next, jumper"
				:total="totalResultCount">
			</el-pagination>
		</div>
	</div>
	
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: true,
				colid:'55d4a739ba52424199ac56206c2c446c',
				colname:'0523研讨会福利',
				pageNum: 1,
				pageSize: 8,
				totalResultCount: 0,
				resultDataList: [
					{
						id:1325043,
						title:'李正波：以新型消费拓展内需新空间'
					},
					{
						id:1325042,
						title:'王浩彬：开展人工智能+行动，培育新质生产力强大引擎'
					},
					{
						id:1324882,
						title:'牛犁：宏观政策加力增效 经济运行更趋平稳——2024年宏观经济形势分析与展望'
					},
					{
						id:1324879,
						title:'徐策：站在中期看未来，立足当下谋发展 融合发展成效及前景望'
					},
				],
				searchResultShow:false,
				searchKey:'',
			}
		},
		components:{

		},
		created:function(){
			
		},
		mounted:function(){
			document.title='0523研讨会福利-数字中国专版';
			this.$track([
				['pagetype','0523研讨会福利列表'],
				['reqtype','2'],
				['column',this.colid]
			]);
			// this.searchfnc();
		},
		methods: {
			searchfnc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'get',
						url: 'article/searchArticles',
						responseType: 'json',
						params: {
							columnID:this.colid,
							iPage: this.pageNum,
							pageSize: this.pageSize,
							orderBy:'publishtime',
							isDesc:'1',
						},
					})
					.then(function(response) {
						_this.resultDataList = response.data.data.data.data;
						_this.totalResultCount = response.data.data.data.totalcount;
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			changePageSize:function(pagesize){
				this.pageSize=pagesize;
				this.searchfnc();
			},
			changeSearchPage: function(page) {
				this.pageNum = page;
				this.searchfnc();
			},
		}
	}
</script>

<style>
</style>
